module.exports = __webpack_public_path__ + "media/new/pay-metamask-5fd77609.svg";